// extracted by mini-css-extract-plugin
module.exports = {"spotlight":"Spotlight_spotlight__1ovwH","at-hide":"Spotlight_at-hide__1bNBP"};